import { Box, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import { useTheme } from '@emotion/react'

const Title = ({ variant = 'h5', title, description, secColor = 'secondary.text', color = 'primary.main', align = 'center', sx, onClick }) => {
    const themeM = useTheme();
    const isMobile = useMediaQuery(themeM.breakpoints.down('sm'));
    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: align, gap:2, my:1,...sx}} 
            onClick={onClick}>
                <Typography variant={isMobile ? 'h6' : variant} fontWeight={600} color={color} sx={{ textTransform: 'capitalize' }} >{title}</Typography>
                {description && description?.split('.')?.map((part, index) => (
                    <Typography key={index} color={secColor} sx={{ textAlign: 'center', lineHeight: 1.7, fontWeight: {md: 500, xs: 'bold'  } }} variant={isMobile ? 'body1' : 'body1'} >{part}</Typography>
                ))}
            </Box>
        </>
    )
}

export default Title